import TeamList from "./team-list";

export default TeamList;